import React from 'react';
import { Field } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';

const SubForm = ({ fields, intl, loadRegionsLookup, managersLookup, formValues, updatePossibleRegions }) => (
	<div>
		{fields.map((name, index) => (
			<div className="display-flex gap-20 ui-form" key={index}>
				<div className="ui-form__element min-width-300">
					<Field
						name={`${name}.manager`}
						placeholder={intl('Select manager') }
						component={SelectField}
						multi={false}
						showLabel={false}
						options={managersLookup}
						onChange={
							() => {
								setTimeout(
									updatePossibleRegions
										.bind(null, index),
									500
								);
							}
						}
					/>
				</div>
				<div className="ui-form__element min-width-300">
					<Field
						name={`${name}.regions`}
						placeholder={intl('Select region') }
						component={SelectField}
						multi={true}
						showLabel={false}
						options={loadRegionsLookup}
					/>
				</div>

				<button type="button"  className="ui-btn ui-btn-cancel del-manager" onClick={() => fields.remove(index)}>
        -
				</button>
			</div>
		))}
		<button type="button"  className="ui-btn ui-btn-primary" onClick={() => fields.push({ })}>
    Add additional manager (s)
		</button>
	</div>
);

export default SubForm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/form/additional-managers.js